import * as commWebApi from '@/api/modules/commWebApi';
import { Api, Spectra, SpectraModule } from '@/decorators';

@Spectra({ namespaced: true, name: 'Model' })
export default class extends SpectraModule {
  @Api() modelTranslation = commWebApi.postCommWebApiModelTranslation;
}
